module.exports = __webpack_public_path__ + "fontello.5611b046c28df3c35322.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/font/fontello.eot?3640046
// module id = ../../../../../src/assets/font/fontello.eot?3640046
// module chunks = styles